const config = window.weftConfig;

export function titleCaseString(str) {
  if (!str) {
    return '';
  }

  return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase());
}


function getUrl(params) {
  if(config.AWS_S3_ENDPOINT === "http://s3:5004")
    return `http://localhost:5004/${params.Bucket}/${params.Key}`
  else
    return `${config.AWS_S3_ENDPOINT}/${params.Bucket}/${params.Key}`
}


export function s3url(bucketColonKey) {
  var url = '';
  if (typeof bucketColonKey === 'string' && bucketColonKey.indexOf(':') > -1) {
    var bucket = bucketColonKey.split(':')[0];
    var key = bucketColonKey.split(':')[1];
    if (config.AWS_S3_ENDPOINT && !config.AWS_S3_ENDPOINT.includes('s3.amazonaws.com')) {
      url = getUrl({ Bucket: bucket, Key: key });
    } else {
      url = `https://s3.amazonaws.com/${bucket}/${key}`;
    }
    if (bucket === '(renderer)') {
      url = `${config.RENDERER_URL}/${key}`;
    }
  }
  return url;
};


export function s3CacheUrl(s3url, size=undefined, gifVideo=false) {
  if (typeof s3url !== 'string' || !s3url instanceof String)
    return;

  var qSize = size;
  if(size) {
    if(size <= 260)
      qSize = 260;
    else if(size <= 450)
      qSize = 450;
    else
      qSize = undefined;
  }

  var urlParts = s3url.match(/(https:\/\/s3\.amazonaws\.com\/)(.*?)\/(.*)/);

  if(urlParts) {
    var bucket = urlParts[2];
    var key = urlParts[3];

    // Handle Cloudflare caching and Imgix caching differently
    if(config.USE_IMGIX && (/(.jpg|.png)$/i.test(key))) {
      // Overrride weft-public-assets bucket name due to Imgix config weirdness
      if(bucket === 'weft-public-assets') {
        bucket = 'weft-public-assets-production';
      }
      return size ? `https://${bucket}.imgix.net/${key}?auto=format&q=75&ch=DPR&w=${size}`: `https://${bucket}.imgix.net/${key}?auto=format&q=75&ch=DPR`;
    } else if(config.USE_IMGIX && (/(.gif)$/i.test(key)) && gifVideo) {
      // Overrride weft-public-assets bucket name due to Imgix config weirdness
      if(bucket === 'weft-public-assets') {
        bucket = 'weft-public-assets-production';
      }
      return size ? `https://${bucket}.imgix.net/${key}?fm=mp4&q=75&ch=DPR&w=${size}`: `https://${bucket}.imgix.net/${key}?fm=mp4&q=75&ch=DPR`;
    } else if(config.WEFT_IMAGE_CACHE_URL) {
      return qSize ? `${config.WEFT_IMAGE_CACHE_URL}/${bucket}/${qSize}/${key}` : `${config.WEFT_IMAGE_CACHE_URL}/${bucket}/${key}`;
    }
  }
  return s3url;
};

export function rendererPreviewUrl(design_id, version_id, width) {
  if(config.USE_IMGIX) {
    var bucket = config.env == 'production' ? 'weft-design-previews' : `weft-design-previews-${config.env}`;
    return s3CacheUrl(`https://s3.amazonaws.com/${bucket}/${design_id}.jpg`, width);
  } else {
    return `${config.RENDERER_URL}/design/${design_id}/${version_id}/0?nx=200&zoomlevel=0`;
  }
}
